<template>
  <with-actions>
    <div class="row">
      <div class="col-6">
        <div class="card mb-3">
          <div class="card-body">
            <div class="row m-1">
              <h3>Filter carriers</h3>
            </div>
            <div class="row">
              <div class="col">
                <label>Carrier type</label>
                <select class="form-control" placeholder="Carrier type" v-model="filter_carrier_type">
                  <option :value="null">-</option>
                  <option v-for="carrierType in carrier_types" :value="carrierType" :key="carrierType.id">
                    {{ carrierType.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6" v-if="filter_carrier_type">
        <div class="card mb-3">
          <div class="card-body">
            <div class="row m-1">
              <h3>Filter carrier attributes</h3>
            </div>
            <div class="row">
              <div class="col">
                <label>Carrier attribute key</label>
                <select class="form-control" placeholder="Carrier attribute key" v-model="filter_carrier_attr_key">
                  <option :value="null">-</option>
                  <option v-for="attr in filter_carrier_type.local_attrs" :value="attr.attr_key" :key="attr.id">
                    {{ attr.attr_name }}
                  </option>
                </select>
              </div>
              <div class="col">
                <label>Carrier attribute value</label>
                <input class="form-control" v-model="filter_carrier_attr_value" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="mb-0 text-muted">
      <span>{{ 'found' | t }} {{ carriers.length }}</span
      ><span class="pl-1" v-if="carriers.length === 1">{{ 'carrier' | t }}</span
      ><span class="pl-1" v-else>{{ 'carriers' | t }}</span>
    </p>
    <lazy-table ref="table" v-model="carriers" model="carrier_indexes" :params="query" :autoload="true">
      <div class="m-3 mt-4">
        <table class="table table-hover table-responsive w-100 d-block d-md-table">
          <thead>
            <tr>
              <th>{{ 'carrier' | t | titlecase }}</th>
              <th>{{ 'carrier_type' | t | titlecase }}</th>
              <th>{{ 'customer' | t | titlecase }}</th>
              <th class="text-right" v-if="can('write_customer_tokens')">{{ 'impersonate' | t }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="carrier in carriers" :key="carrier.id">
              <router-link
                class="pointer"
                :to="{ name: 'customers_show', params: { customer_id: carrier.customer.id } }"
                tag="td"
                >{{ carrier.name }}</router-link
              >
              <router-link
                class="pointer"
                :to="{ name: 'carrier_type', params: { carrier_type_id: carrier.carrier_type.id } }"
                tag="td"
                >{{ carrier.carrier_type.name }}</router-link
              >
              <router-link
                class="pointer"
                :to="{ name: 'customers_show', params: { customer_id: carrier.customer.id } }"
                tag="td"
                >{{ carrier.customer.name }}</router-link
              >
              <td class="text-right" v-if="can('write_customer_tokens')">
                <impersonate-button :tenant="carrier.customer.tenant_name"></impersonate-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </lazy-table>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data() {
    return {
      query: {
        include: 'carrier_type,customer',
        filter: {}
      },
      carriers: [],
      carrier_types: [],
      filter_carrier_type: '',
      filter_carrier_attr_key: '',
      filter_carrier_attr_value: ''
    };
  },
  computed: {
    carrier_attr_filter() {
      if (
        this.filter_carrier_attr_value &&
        this.filter_carrier_attr_value.length > 0 &&
        this.filter_carrier_attr_key &&
        this.filter_carrier_attr_key.length > 0
      ) {
        return `${this.filter_carrier_attr_key}:${this.filter_carrier_attr_value}`;
      } else {
        return '';
      }
    }
  },

  watch: {
    query: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      }
    },
    carrier_attr_filter: function () {
      this.$set(this.query.filter, 'carrier_attr', this.carrier_attr_filter);
    },
    filter_carrier_type: function () {
      this.$set(this.query.filter, 'carrier_type_id', this.filter_carrier_type.id);
    }
  },
  mounted() {
    if (this.can('read_carrier_types')) {
      Api.findAllPages('carrier_types', {
        sort: 'name',
        fields: { carrier_types: 'name,id,local_attrs' }
      }).then(({ data }) => {
        this.carrier_types = data;
      });
    }
  },
  created() {
    this.$store.commit('setBreadcrumbs', [{ to: { name: 'carrier_types' }, text: this.$i18n.t('carrier_types') }]);
  }
};
</script>

<style scoped>
table.table th,
table.table td {
  border-top: none;
}

.pointer {
  cursor: pointer;
}
</style>
